import React, { useEffect, useState } from "react";
import { Label,Input } from "reactstrap";

import Breadcrumbs from '../../components/Common/Breadcrumb'



export default function Track() {

    const [coordinates, setCoordinates] = useState([]);
    const[email, setEmail] = useState("");
    const[company, setCompany] = useState('');
    const[search, setSearch] = useState('')

    useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setCompany(data.company)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])


  useEffect(()=>{
    const fetchData=async()=>{
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/trackOrders?company=${company}`)

        const data = await res.json();
        setCoordinates(data)
    }

    if(company){
        fetchData();
    }

  },[company])
  const fetchOrders=async()=>{
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/trackOrders?company=${company}`)

        const data = await res.json();
        setCoordinates(data)
    }



  useEffect(()=>{
    const searchOrder =async()=>{
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/searchCoordinates?company=${company}&search=${search}`);
        const data = await res.json();
        setCoordinates(data)

    }

    if(search){
        searchOrder();
    }

    if(search == ''){
        fetchOrders();
    }
  },[company,search])




  return (
    <div className='pagesContainer'>
        <Breadcrumbs title="Easybox" breadcrumbItem="Track orders" />
        <div className="card" style={{padding:'10px'}}>
        <div className="searchBar">
            <div className="mb-4" id="mb">
                <Label className="form-label">Search order</Label>
                <Input
                    name="search"
                    className="form-control"
                    placeholder="Search order"
                    type="text"
                    onChange={(e)=>{setSearch(e.target.value)}}
                    value={search}

                />
                
            </div>

        </div>

        <div style={{ height: "80vh" }}>
        <p>Google Map API Missing</p>
      
      {/* <MapContainer center={[-1.28333, 36.81667]} zoom={12} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
        />
        {coordinates.map((coord, index) => (
          <Marker key={index} position={[coord.lat, coord.lng]}>
            <Popup>
              <strong>Order Number:</strong> {coord.orderNumber} <br />
              <strong>Latitude:</strong> {coord.lat}, <strong>Longitude:</strong> {coord.lng}
            </Popup>
          </Marker>
        ))}
      </MapContainer> */}
    </div>
        </div>
    </div>
  )
}
